import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFetch, CreateAsyncStatusHandler } from "../../app/SliceUtils";

export const fetchContacts = createAsyncThunk(
    '/api/contact',
    (_, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/contact`, contentType: 'application/x-www-form-urlencoded' }, rejectWithValue)
);

export const fetchAllContacts = createAsyncThunk(
    '/api/contact/all',
    (_, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/contact/all`, contentType: 'application/x-www-form-urlencoded' }, rejectWithValue)
);

export const contactSlice = createSlice({
    name: "contacts",
    initialState: {
        contacts: { data: null, status: null },
        allContacts: { data: null, status: null },
    },
    reducers: {},
    extraReducers: (builder) => {
        CreateAsyncStatusHandler(builder, fetchContacts, 'contacts');
        CreateAsyncStatusHandler(builder, fetchAllContacts, 'allContacts');
    },
});

export default contactSlice.reducer;
